import React, { useEffect, useState, createContext, useContext } from 'react';
export type Lang = 'es' | 'en';
type Translations = { [key in Lang]: {
  [section: string]: {
    [key: string]: string | string[];
  };
} };
export const translations: Translations = {
  es: {
    urgencyBar: {
      offer: 'OFERTA ESPECIAL: Consulta + Evaluación GRATIS — Solo esta semana',
      endsIn: 'Termina en:'
    },
    header: {
      cta: 'Agendar Consulta Gratis'
    },
    hero: {
      badge: '🔥 MÁS DE 5,000 PROCEDIMIENTOS EXITOSOS',
      headlineStart: '¿Cansada de que el Gimnasio',
      headlineHighlight: 'NO Elimine',
      headlineEnd: 'Esa Grasa Rebelde?',
      subheadline: 'Miles de mujeres hispanas en USA ya transformaron su figura con procedimientos mínimamente invasivos.',
      anchorPrice: 'Desde solo $89/mes',
      financing: 'con financiamiento aprobado.',
      trust1: '15+ Años de Experiencia',
      trust2: 'Tecnología FDA Approved',
      trust3: 'Resultados Naturales',
      ctaPrimary: 'Agenda tu Consulta GRATIS',
      ctaSecondary: 'Ver Resultados Primero'
    },
    ticker: {
      messages: ['María de Miami agendó su consulta hace 3 min', 'Isabella de Los Angeles agendó su evaluación hace 4 min', 'Carmen de Houston completó su Lipo 360 hace 2 semanas', 'Sofía de New York calificó para financiamiento hace 10 min', 'Laura de Las Vegas inició su transformación hace 5 min', 'Patricia de Phoenix reservó su evaluación gratuita']
    },
    painSection: {
      title: '¿Te Identificas con Esto?',
      subtitle: 'Sé honesta contigo misma... ¿cuántas de estas situaciones vives a diario?',
      pain1: 'Llevas años en el gimnasio sin ver cambios en esas zonas difíciles',
      pain2: 'Evitas usar bikini o ropa ajustada porque te sientes insegura',
      pain3: 'Has probado dietas estrictas pero la grasa localizada no se va',
      pain4: 'Te miras al espejo y extrañas el cuerpo que tenías antes',
      solutionTitle: 'No es tu culpa.',
      solutionText: 'La grasa localizada a menudo es genética o hormonal y NO responde al ejercicio por más que te esfuerces. Necesitas una solución médica probada.',
      solutionCta: 'Descubre la solución ahora'
    },
    results: {
      title: 'Resultados Reales.',
      subtitle: 'Transformaciones Reales.',
      rating: '4.9/5 Promedio',
      satisfaction: '98% Satisfacción',
      cta: 'Quiero Resultados Como Estos'
    },
    testimonials: {
      t1: 'Finalmente me reconocí en el espejo. El procedimiento fue más sencillo de lo que esperaba y los resultados son exactamente lo que quería: naturales.',
      t2: 'Después de años de frustración en el gimnasio, DermaClinic trabajó exactamente en las zonas que no respondían. El personal fue increíblemente profesional.',
      t3: 'La recuperación fue muy rápida. Volví al trabajo en dos días. Han pasado 6 meses y mi piel se ve más firme que en mis 20s.',
      t4: 'Tenía miedo del dolor, pero fue mucho menos de lo que esperaba. Al tercer día ya estaba caminando normal. ¡Increíble experiencia!',
      t5: 'Lo mejor fue que pude financiar todo. Pago menos de lo que gastaba en el gym al mes. Ahora tengo el cuerpo que siempre quise.',
      t6: 'Mi esposo no podía creer la diferencia. Me siento como nueva, con mucha más confianza. El equipo médico es excelente.'
    },
    stats: {
      procedures: 'Procedimientos',
      experience: 'Años de Experiencia',
      cities: 'Ciudades en USA',
      satisfaction: 'Satisfacción',
      tagline: 'La clínica #1 de contorno corporal para la comunidad hispana en USA'
    },
    benefits: {
      title: '¿Por Qué Elegir DermaClinic?',
      subtitle: 'A diferencia de otras clínicas, nos especializamos 100% en procedimientos mínimamente invasivos.',
      b1Title: 'Tecnología Láser Avanzada',
      b1Desc: 'Sin cirugía mayor. Usamos láser de precisión para derretir la grasa antes de extraerla.',
      b2Title: 'Recuperación Rápida',
      b2Desc: 'Vuelve a tu rutina en 2-5 días, no en semanas. Sin drenajes dolorosos.',
      b3Title: 'Especialistas Certificados',
      b3Desc: 'Médicos con miles de horas de experiencia específica en contorno corporal.',
      b4Title: 'Resultados Naturales',
      b4Desc: 'Esculpimos tu cuerpo respetando tus curvas naturales. Nadie notará que te operaste.'
    },
    financing: {
      badge: '💲 Financiamiento Disponible',
      title: 'Tu Transformación Desde Solo',
      price: '$89/Mes',
      subtitle: 'El dinero NO debería ser un obstáculo para sentirte increíble. Los planes inician desde $89/mes y tu plan exacto se confirma en tu consulta gratuita, según el tratamiento que elijas.',
      f1: 'Pre-aprobación en minutos',
      f2: 'Sin afectar tu crédito',
      f3: 'Planes hasta 60 meses',
      cta: 'Consulta GRATIS + Pre-Aprobación'
    },
    moreTestimonials: {
      title: 'Más Historias de Éxito'
    },
    faq: {
      title: 'Preguntas Frecuentes',
      q1: '¿Duele el procedimiento?',
      a1: 'La mayoría de nuestros procedimientos son mínimamente invasivos y se realizan con anestesia local. El dolor es mínimo y la mayoría de las pacientes describen solo una molestia leve tipo "agujetas" después del ejercicio.',
      q2: '¿Cuánto cuesta?',
      a2: 'Es una inversión en ti, y el costo varía según el tratamiento y tus objetivos. El financiamiento la hace accesible desde $89/mes, y en tu consulta de evaluación 100% GRATUITA un especialista te da un presupuesto exacto y la mejor opción de pago para ti.',
      q3: '¿Es seguro?',
      a3: 'Absolutamente. Contamos con especialistas certificados, tecnología aprobada por la FDA y más de 15 años de experiencia realizando más de 5,000 procedimientos exitosos.',
      q4: '¿Cuánto dura la recuperación?',
      a4: 'Gracias a nuestra tecnología avanzada, la recuperación es mucho más rápida que la cirugía tradicional. La mayoría de las pacientes regresan a sus actividades normales en 2 a 5 días.',
      q5: '¿Qué pasa si no califico para financiamiento?',
      a5: 'Trabajamos con múltiples socios financieros (CareCredit, Affirm, Alphaeon, United Medical Credit). La mayoría de nuestros pacientes califican para al menos una opción. ¡Te ayudamos a encontrar la mejor para ti!',
      q6: '¿Los resultados son permanentes?',
      a6: 'Sí, las células grasas eliminadas no vuelven a crecer. Con un estilo de vida saludable, tus resultados serán duraderos y espectaculares.'
    },
    finalCTA: {
      title: 'No Esperes Más.',
      subtitle: 'Tu Transformación Comienza HOY.',
      text: 'Recuerda: La consulta es 100% gratuita y sin compromiso. Solo tienes que dar el primer paso.',
      urgency: 'Las citas de esta semana se están llenando rápido',
      button: '¡SÍ! Quiero Agendar Mi Consulta GRATIS'
    },
    form: {
      title: 'Verifica Disponibilidad',
      subtitle: 'Completa el formulario para asegurar tu espacio.',
      step1: 'Ubicación',
      step2: 'Tratamiento',
      step3: 'Pago',
      step4: 'Tiempo',
      step5: 'Datos',
      step1Title: '¿Dónde te gustaría atenderte?',
      step1Success: '¡Excelente! Tenemos clínica en',
      step1Error: 'Por favor selecciona una ciudad',
      step2Title: '¿Qué área quieres transformar?',
      step2Success: 'es uno de nuestros procedimientos más populares.',
      step2Error: 'Por favor selecciona un tratamiento',
      financeTitle: '¿Cuentas con crédito activo en los EE.UU.?',
      financeSubtitle: 'Esto nos ayuda a asegurar tu plan de $89/mes hoy mismo.',
      optSsn: 'Sí, tengo SSN o ITIN',
      optCash: 'No, pagaré en efectivo',
      optOptions: 'Quiero ver mis opciones',
      financeError: 'Por favor selecciona una opción',
      urgencyTitle: '¿Cuándo quieres ver tu transformación?',
      urgencySubtitle: 'Estamos agendando para este mes.',
      optAsap: '¡YA! - Lista para mi cambio',
      optMonth: 'En los próximos 30 días',
      optInfo: 'Solo busco precios',
      priorityLabel: 'Prioridad Alta',
      timelineTrust: 'Tu selección nos ayuda a asignarte al especialista correcto.',
      timelineError: 'Por favor selecciona una opción',
      verifyingAvailability: 'Verificando disponibilidad en',
      qualifiedTitle: '¡Calificada! Completa el formulario para asegurar tu cupo.',
      step3Title: '¡Casi listo!',
      step3Subtitle: 'Déjanos tus datos y un especialista te llamará para darte un precio personalizado y tus opciones de financiamiento.',
      step3Urgency: '🔥 Solo quedan 3 citas disponibles esta semana',
      labelName: 'Nombre Completo',
      placeholderName: 'Tu nombre completo',
      errorName: 'El nombre es requerido',
      labelEmail: 'Email',
      placeholderEmail: 'tu@email.com',
      errorEmail: 'El email es requerido',
      errorEmailInvalid: 'Por favor ingresa un email válido',
      labelPhone: 'Teléfono',
      placeholderPhone: '(123) 456-7890',
      errorPhone: 'Ingresa un número válido de EE.UU. (10 dígitos)',
      consentText: 'Acepto recibir confirmaciones y recordatorios por WhatsApp.',
      errorConsent: 'Debes aceptar para continuar',
      back: 'Atrás',
      continue: 'CONTINUAR',
      submit: 'VERIFICAR DISPONIBILIDAD',
      processing: 'Procesando...',
      security: 'Tus datos están 100% seguros y encriptados.'
    },
    beforeAfter: {
      badge: '📸 Casos Documentados',
      title: 'Resultados Reales en Pacientes DermaClinic',
      subtitle: 'Cada transformación es única. Estos son casos reales de pacientes que confiaron en nuestro equipo.',
      before: 'Antes',
      after: 'Después',
      c1: 'Resultados a las 8 semanas post-procedimiento',
      c2: 'Resultados a las 12 semanas post-procedimiento',
      c3: 'Resultados a las 6 semanas post-procedimiento',
      c4: 'Resultados inmediatos post-procedimiento',
      disclaimer: '* Resultados individuales pueden variar. Las imágenes son representativas. Evaluación médica requerida antes de cualquier procedimiento. Consulta con nuestros especialistas para determinar el tratamiento adecuado para tu caso.',
      cta: 'Quiero Mi Transformación'
    },
    stickyMobile: {
      urgency: '⚡ Consulta GRATIS — Cupos Limitados',
      cta: 'Agenda tu Consulta Ahora'
    },
    thankYou: {
      title: '¡Gracias por tu Solicitud!',
      subtitle: 'Tu consulta ha sido recibida exitosamente. Nuestro equipo se pondrá en contacto contigo muy pronto para confirmar tu cita.',
      statusTitle: 'Solicitud Recibida',
      statusRecent: 'Ya recibimos tu solicitud recientemente. Nuestro equipo se pondrá en contacto contigo muy pronto.',
      statusNew: 'Tu solicitud ha sido registrada exitosamente.',
      nextStepsTitle: 'Qué Sigue Ahora',
      step1: 'Un especialista revisa tu solicitud y prepara tu consulta personalizada.',
      step2: 'Un especialista te llama en los próximos 2 minutos desde el +1 (702) 660-4534 para tu evaluación.',
      step3: 'Conversas tu plan personalizado, precio exacto y opciones de financiamiento — sin compromiso.',
      checkSpam: 'Si no logramos conectarte en la llamada, te contactamos por WhatsApp dentro de 24 horas.',
      callNowIntro: '✅ Recibimos tu información',
      callNowMessage: 'En menos de 2 minutos un especialista te llamará desde el +1 (702) 660-4534 (guarda el número) para tu evaluación gratuita y darte tu precio y financiamiento personalizados.',
      callNowPrompt: '¿No quieres esperar? Llámanos ahora:',
      callNowButton: 'Llamar Ahora',
      expectTitle: 'Qué Esperar en tu Consulta',
      expect1Title: 'Evaluación Médica Completa',
      expect1Desc: 'Nuestros especialistas revisarán tu caso y discutirán tus objetivos estéticos.',
      expect2Title: 'Plan Personalizado',
      expect2Desc: 'Recibirás un plan de tratamiento diseñado específicamente para ti.',
      expect3Title: 'Precios Transparentes',
      expect3Desc: 'Costos claros y honestos para tu caso, con opciones de financiamiento desde $89/mes y próximos pasos — sin presión.',
      contactTitle: '¿Tienes preguntas urgentes?',
      contactSubtitle: 'Nuestro equipo está disponible para ayudarte',
      footer: '© 2026 DermaClinic Center. Todos los derechos reservados.'
    },
    treatments: {
      lipo360: 'Contorno completo',
      laserlipo: 'Tecnología avanzada',
      bbl: 'Brazilian Butt Lift',
      chinlipo: 'Definición de mandíbula',
      facetightening: 'Rejuvenecimiento facial',
      bodycontouring: 'Escultura corporal',
      mommymakeover: 'Transformación completa'
    }
  },
  en: {
    urgencyBar: {
      offer: 'SPECIAL OFFER: Free Consultation + Evaluation — This week only',
      endsIn: 'Ends in:'
    },
    header: {
      cta: 'Book Free Consultation'
    },
    hero: {
      badge: '🔥 OVER 5,000 SUCCESSFUL PROCEDURES',
      headlineStart: 'Tired of the Gym',
      headlineHighlight: 'NOT Eliminating',
      headlineEnd: 'That Stubborn Fat?',
      subheadline: 'Thousands of women in the USA have already transformed their figures with minimally invasive procedures.',
      anchorPrice: 'Starting at just $89/mo',
      financing: 'with approved financing.',
      trust1: '15+ Years Experience',
      trust2: 'FDA Approved Tech',
      trust3: 'Natural Results',
      ctaPrimary: 'Book Your FREE Consultation',
      ctaSecondary: 'See Results First'
    },
    ticker: {
      messages: ['Maria from Miami booked her consultation 3 min ago', 'Isabella from Los Angeles booked her evaluation 4 min ago', 'Carmen from Houston completed her Lipo 360 2 weeks ago', 'Sofia from New York qualified for financing 10 min ago', 'Laura from Las Vegas started her transformation 5 min ago', 'Patricia from Phoenix reserved her free evaluation']
    },
    painSection: {
      title: 'Do You Identify With This?',
      subtitle: 'Be honest with yourself... how many of these situations do you experience daily?',
      pain1: "You've been at the gym for years without seeing changes in those difficult areas",
      pain2: 'You avoid wearing bikinis or tight clothes because you feel insecure',
      pain3: "You've tried strict diets but localized fat won't go away",
      pain4: 'You look in the mirror and miss the body you used to have',
      solutionTitle: "It's not your fault.",
      solutionText: 'Localized fat is often genetic or hormonal and DOES NOT respond to exercise no matter how hard you try. You need a proven medical solution.',
      solutionCta: 'Discover the solution now'
    },
    results: {
      title: 'Real Results.',
      subtitle: 'Real Transformations.',
      rating: '4.9/5 Average',
      satisfaction: '98% Satisfaction',
      cta: 'I Want Results Like These'
    },
    testimonials: {
      t1: 'I finally recognized myself in the mirror. The procedure was easier than I expected and the results are exactly what I wanted: natural.',
      t2: "After years of frustration at the gym, DermaClinic targeted exactly the areas that wouldn't respond. The staff was incredibly professional.",
      t3: "Recovery was very fast. I went back to work in two days. It's been 6 months and my skin looks firmer than in my 20s.",
      t4: 'I was afraid of the pain, but it was much less than I expected. By the third day I was walking normally. Incredible experience!',
      t5: 'The best part was that I could finance everything. I pay less than what I spent on the gym per month. Now I have the body I always wanted.',
      t6: "My husband couldn't believe the difference. I feel brand new, with much more confidence. The medical team is excellent."
    },
    stats: {
      procedures: 'Procedures',
      experience: 'Years Experience',
      cities: 'Cities in USA',
      satisfaction: 'Satisfaction',
      tagline: '#1 Body Contouring Clinic for the Hispanic Community in USA'
    },
    benefits: {
      title: 'Why Choose DermaClinic?',
      subtitle: 'Unlike other clinics, we specialize 100% in minimally invasive procedures.',
      b1Title: 'Advanced Laser Technology',
      b1Desc: 'No major surgery. We use precision laser to melt fat before extracting it.',
      b2Title: 'Rapid Recovery',
      b2Desc: 'Return to your routine in 2-5 days, not weeks. No painful drains.',
      b3Title: 'Certified Specialists',
      b3Desc: 'Doctors with thousands of hours of specific experience in body contouring.',
      b4Title: 'Natural Results',
      b4Desc: 'We sculpt your body respecting your natural curves. No one will notice you had surgery.'
    },
    financing: {
      badge: '💲 Financing Available',
      title: 'Your Transformation From Just',
      price: '$89/Mo',
      subtitle: 'Money should NOT be an obstacle to feeling amazing. Plans start from $89/month, and your exact plan is confirmed in your free consultation based on the treatment you choose.',
      f1: 'Pre-approval in minutes',
      f2: 'No impact on your credit',
      f3: 'Plans up to 60 months',
      cta: 'Free Consultation + Pre-Approval'
    },
    moreTestimonials: {
      title: 'More Success Stories'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'Does the procedure hurt?',
      a1: 'Most of our procedures are minimally invasive and performed under local anesthesia. Pain is minimal and most patients describe only mild soreness like "muscle aches" after exercise.',
      q2: 'How much does it cost?',
      a2: "It's an investment in yourself, and the cost varies by treatment and your goals. Financing makes it accessible from $89/month, and in your 100% FREE evaluation consultation a specialist gives you an exact quote and the best payment option for you.",
      q3: 'Is it safe?',
      a3: 'Absolutely. We have certified specialists, FDA-approved technology, and over 15 years of experience performing more than 5,000 successful procedures.',
      q4: 'How long is recovery?',
      a4: 'Thanks to our advanced technology, recovery is much faster than traditional surgery. Most patients return to normal activities in 2 to 5 days.',
      q5: "What if I don't qualify for financing?",
      a5: 'We work with multiple financial partners (CareCredit, Affirm, Alphaeon, United Medical Credit). Most of our patients qualify for at least one option. We help you find the best one for you!',
      q6: 'Are results permanent?',
      a6: 'Yes, the eliminated fat cells do not grow back. With a healthy lifestyle, your results will be long-lasting and spectacular.'
    },
    finalCTA: {
      title: "Don't Wait Any Longer.",
      subtitle: 'Your Transformation Starts TODAY.',
      text: 'Remember: The consultation is 100% free and no obligation. You just have to take the first step.',
      urgency: 'Appointments for this week are filling up fast',
      button: 'YES! I Want to Book My FREE Consultation'
    },
    form: {
      title: 'Check Availability',
      subtitle: 'Complete the form to secure your spot.',
      step1: 'Location',
      step2: 'Treatment',
      step3: 'Payment',
      step4: 'Timeline',
      step5: 'Details',
      step1Title: 'Where would you like to be seen?',
      step1Success: 'Excellent! We have a clinic in',
      step1Error: 'Please select a city',
      step2Title: 'What area do you want to transform?',
      step2Success: 'is one of our most popular procedures.',
      step2Error: 'Please select a treatment',
      financeTitle: 'Do you currently have active credit in the USA?',
      financeSubtitle: 'This helps us secure your $89/mo financing plan today.',
      optSsn: 'Yes, I have SSN or ITIN',
      optCash: 'No, I will pay cash',
      optOptions: 'I want to check my options',
      financeError: 'Please select an option',
      urgencyTitle: 'When do you want to see your transformation?',
      urgencySubtitle: 'We are currently booking for this month.',
      optAsap: 'ASAP - Ready for my change',
      optMonth: 'Next 30 days',
      optInfo: 'Just getting prices',
      priorityLabel: 'High Priority',
      timelineTrust: 'Your selection helps us assign the right specialist for you.',
      timelineError: 'Please select an option',
      verifyingAvailability: 'Verifying availability in',
      qualifiedTitle: 'Qualified! Complete the form to secure your spot.',
      step3Title: 'Almost done!',
      step3Subtitle: 'Leave your details and a specialist will call you with personalized pricing and your financing options.',
      step3Urgency: '🔥 Only 3 appointments left this week',
      labelName: 'Full Name',
      placeholderName: 'Your full name',
      errorName: 'Name is required',
      labelEmail: 'Email',
      placeholderEmail: 'your@email.com',
      errorEmail: 'Email is required',
      errorEmailInvalid: 'Please enter a valid email',
      labelPhone: 'Phone',
      placeholderPhone: '(123) 456-7890',
      errorPhone: 'Please enter a valid US number (10 digits).',
      consentText: 'I agree to receive confirmations and reminders via WhatsApp.',
      errorConsent: 'You must agree to continue',
      back: 'Back',
      continue: 'CONTINUE',
      submit: 'CHECK AVAILABILITY',
      processing: 'Processing...',
      security: 'Your data is 100% secure and encrypted.'
    },
    beforeAfter: {
      badge: '📸 Documented Cases',
      title: 'Real Results on DermaClinic Patients',
      subtitle: 'Every transformation is unique. These are real cases of patients who trusted our team.',
      before: 'Before',
      after: 'After',
      c1: 'Results at 8 weeks post-procedure',
      c2: 'Results at 12 weeks post-procedure',
      c3: 'Results at 6 weeks post-procedure',
      c4: 'Immediate post-procedure results',
      disclaimer: '* Individual results may vary. Images are representative. Medical evaluation required before any procedure. Consult with our specialists to determine the appropriate treatment for your case.',
      cta: 'I Want My Transformation'
    },
    stickyMobile: {
      urgency: '⚡ FREE Consultation — Limited Spots',
      cta: 'Book Your Consultation Now'
    },
    thankYou: {
      title: 'Thank You for Your Request!',
      subtitle: 'Your inquiry has been received successfully. Our team will contact you very soon to confirm your appointment.',
      statusTitle: 'Request Received',
      statusRecent: 'We already received your request recently. Our team will contact you very soon.',
      statusNew: 'Your request has been registered successfully.',
      nextStepsTitle: 'What Happens Next',
      step1: 'A specialist reviews your request and prepares your personalized consultation.',
      step2: 'A specialist calls you within the next 2 minutes from +1 (702) 660-4534 for your evaluation.',
      step3: 'You discuss your personalized plan, exact pricing, and financing options — no obligation.',
      checkSpam: "If we can't connect on the call, we'll reach you via WhatsApp within 24 hours.",
      callNowIntro: '✅ We received your information',
      callNowMessage: 'Within 2 minutes a specialist will call you from +1 (702) 660-4534 (save the number) for your free evaluation and to give you your personalized pricing and financing.',
      callNowPrompt: "Don't want to wait? Call us now:",
      callNowButton: 'Call Now',
      expectTitle: 'What to Expect at Your Consultation',
      expect1Title: 'Full Medical Evaluation',
      expect1Desc: 'Our specialists will review your case and discuss your aesthetic goals.',
      expect2Title: 'Personalized Plan',
      expect2Desc: 'You will receive a treatment plan designed specifically for you.',
      expect3Title: 'Transparent Pricing',
      expect3Desc: 'Clear, honest costs for your case, with financing options from $89/month and next steps — no pressure.',
      contactTitle: 'Have urgent questions?',
      contactSubtitle: 'Our team is available to help you',
      footer: '© 2026 DermaClinic Center. All rights reserved.'
    },
    treatments: {
      lipo360: 'Full contour',
      laserlipo: 'Advanced technology',
      bbl: 'Brazilian Butt Lift',
      chinlipo: 'Jawline definition',
      facetightening: 'Facial rejuvenation',
      bodycontouring: 'Body sculpting',
      mommymakeover: 'Complete transformation'
    }
  }
};
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('es');
  useEffect(() => {
    // Check localStorage first
    const savedLang = localStorage.getItem('dermaclinic_lang') as Lang;
    if (savedLang && (savedLang === 'es' || savedLang === 'en')) {
      setLangState(savedLang);
    } else {
      // Auto-detect
      const browserLang = navigator.language.toLowerCase();
      if (browserLang.startsWith('es')) {
        setLangState('es');
      } else {
        setLangState('en'); // Default to English for non-Spanish browsers? Or default to ES?
        // Given the target audience is Hispanic women in USA, maybe default ES?
        // But the prompt says "auto-detect". If browser is EN, show EN.
        // If browser is ES, show ES.
        // Let's stick to: if starts with 'es' -> 'es', else -> 'en' (as requested in prompt)
      }
    }
  }, []);
  const setLang = (newLang: Lang) => {
    setLangState(newLang);
    localStorage.setItem('dermaclinic_lang', newLang);
  };
  const t = (path: string) => {
    const keys = path.split('.');
    let current: any = translations[lang];
    for (const key of keys) {
      if (current[key] === undefined) {
        console.warn(`Translation missing for key: ${path} in language: ${lang}`);
        return path;
      }
      current = current[key];
    }
    return current;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-600" data-mp="1miwfiz94atxp">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}